import React, { FC, useState, useMemo } from 'react';
import { Box, styled, SxProps, Theme } from '@mui/material';
import Tippy from '@tippyjs/react';

type Props = {
  text?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  handleActionChangeType?: () => void;
};

const ActionCellPopup: FC<Props> = ({ text, sx, disabled, handleActionChangeType }) => {
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const hide = () => setVisible(false);

  const dropDownContent = (
    <div className="menu-container">
      <button type="button" onClick={handleActionChangeType} className="menu-item">
        Change Assignment Type
      </button>
      {/* <div onClick={() => onClickHandler('change')} className="menu-item">
       Change Assignment
      </div> */}
    </div>
  );
  const shouldAllowHTML = () => true;
  const shouldinteractive = () => true;

  return (
    <Tippy
      // ref={tippyRef}
      content={dropDownContent}
      visible={visible}
      onClickOutside={hide}
      allowHTML={shouldAllowHTML()}
      arrow={false}
      appendTo={document.body}
      interactive={shouldinteractive()}
      placement="left"
    >
      {disabled === true ? (
        <Box
          sx={{
            border: `1px solid #bbbab7`,
            borderRadius: 1,
            color: '#bbbab7',
            padding: '4px',
            fontSize: '12px',
            textAlign: 'center',
            width: '18px',
            height: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {' '}
          ...{' '}
        </Box>
      ) : (
        <Box
          // ref={otherParams.anchorRef}
          // size="small"
          sx={{
            borderRadius: 1,
            border: '1px solid #456BD9',
            padding: '4px',
            fontSize: '12px',
            textAlign: 'center',
            width: '18px',
            height: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={visible ? hide : show}
        >
          ...
        </Box>
      )}
    </Tippy>
  );
};
export default ActionCellPopup;
